/* MUI */
import { Button } from '@mui/material';

/*  NPM  */
import { cloneDeep } from 'lodash';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const ManagedTableClearFilterButton = ({
    'data-trackid': dataTrackid,
    disabledVal,
    filters,
    setFilters
}) => {
    const { t } = useTranslation();

    const clearFilters = () => {
        const currentFilters = cloneDeep(filters);

        Object.values(currentFilters).forEach((currentFilter) => {
            Object.defineProperty(currentFilter, 'values', {
                value: []
            });
        });

        setFilters(currentFilters);
    };

    return (
        <Button
            color="primary"
            data-trackid={`${dataTrackid}_clearFiltersBtn`}
            disabled={!!disabledVal}
            onClick={clearFilters}
            size="small"
            variant="outlined"
            style={{
                marginLeft: '8px',
                marginRight: '8px'
            }}
        >
            {t('ManagedTable.clear_filters')}
        </Button>
    );
};
